import {
  FETCH_USERSLIST_REQUEST,
  FETCH_USERSLIST_SUCCESS,
  FETCH_USERSLIST_FAILURE,
} from "./usersTypes";
import api from "../../utils/Api";
import Axios from "axios";

export const fetchUsersListRequest = () => {
  return {
    type: FETCH_USERSLIST_REQUEST,
  };
};

export const fetchUsersListSuccess = (usersList) => {
  return {
    type: FETCH_USERSLIST_SUCCESS,
    payload: usersList,
  };
};

export const fetchUsersListFailure = (error) => {
  return {
    type: FETCH_USERSLIST_FAILURE,
    payload: error,
  };
};

const CancelToken = Axios.CancelToken;
let cancelRequest;
export const fetchUsersList = (searchKey, sortBy, page) => {
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchUsersListRequest);
    try {
      const response = await api.get(
        "user?search_key=" + searchKey + "&sort_by=" + sortBy + "&page=" + page,
        {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const usersList = response.data.user;
      dispatch(fetchUsersListSuccess(usersList));
    } catch (error) {
      if (Axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchUsersListFailure(errorMsg));
    }
  };
};
